import { tv } from 'tailwind-variants';

const containerStyle = tv({
  base: 'flex relative w-full',
  variants: {
    orientation: {
      vertical: 'flex-col gap-y-1',
      horizontal: 'flex-row gap-x-2 items-center',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
  },
});

const inputStyle = tv({
  base: 'bg-zinc-200 p-0.5 flex flex-1 h-full min-w-0 w-full max-w-full text-sm text-gray-800 data-[placeholder]:text-sm focus-visible:outline-0',
  variants: {
    disabled: {
      true: 'disabled:cursor-not-allowed disabled:text-gray-700 read-only:cursor-not-allowed read-only:text-gray-700',
    },
  },
});

const colorStyle = tv({
  base: 'text-sm font-light text-gray-700',
});

export const colorFieldStyles = {
  container: containerStyle,
  input: inputStyle,
  color: colorStyle,
};
